module.exports = __webpack_public_path__ + "img/team.2badd539.jpg";